import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { TypeInventoryModel } from 'src/app/models/inventory/type-inventory.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TypeInventoryTableModel } from 'src/app/models/tables/inventory/type-inventory-table.mode';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TypeInventoryService {

  constructor(private _httpClient: HttpClient) { }

  createTypeInventory(typeInventoryModel: TypeInventoryModel): Observable<TypeInventoryModel> {
    return this._httpClient.post<TypeInventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeInventory.CreateTypeInventory}`,
      typeInventoryModel);
  }

  deleteTypeInventory(typeInventoryId: number): Observable<TypeInventoryModel> {
    return this._httpClient.delete<TypeInventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeInventory.DeleteTypeInventory}/${typeInventoryId}`);
  }

  getAllTypeInventory(): Observable<Array<TypeInventoryModel>> {
    return this._httpClient.get<Array<TypeInventoryModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeInventory.GetAllTypeInventory}`)
  }

  getColumnsForConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeInventory.GetColumnsForConsultation}`);
  }

  getTypeInventoryById(typeInventoryId: number): Observable<TypeInventoryModel> {
    return this._httpClient.get<TypeInventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeInventory.GetByIdAsync}/${typeInventoryId}`)
  }

  getTypeInventoriesForConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<TypeInventoryTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<TypeInventoryTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeInventory.GetTypeInventoriesForConsultation}`,
      filters, { params: params }
    );
  }

  getTypeInventoryByCode(code: number): Observable<TypeInventoryModel> {
    return this._httpClient.get<TypeInventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeInventory.GetTypeInventoryByCode}/${code}`)
  }


  updateTypeInventory(typeInventoryModel: TypeInventoryModel): Observable<TypeInventoryModel> {
    return this._httpClient.put<TypeInventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeInventory.UpdateTypeInventory}`,
      typeInventoryModel);
  }

}
